import React, { useEffect, useState } from "react";

// 📌 Hook pour gérer les dimensions du textarea
export const useTextareaResize = (
  initialValues: {
    width: string;
    height: string;
    ref: React.RefObject<HTMLTextAreaElement> | null;
  } = { width: "100%", height: "300px", ref: null }
) => {
  const [textareaSize, setTextareaSize] = useState(initialValues);
  // Permet d'adapter la hauteur de la div en dessous du textarea
  useEffect(() => {
    function outputsize() {
      setTextareaSize({
        width:
          `${initialValues.ref?.current?.offsetWidth}px` || initialValues.width,
        height:
          `${initialValues.ref?.current?.offsetHeight}px` ||
          initialValues.height,
        ref: initialValues.ref,
      });
    }
    outputsize();

    if (initialValues.ref?.current) {
      new MutationObserver(outputsize).observe(initialValues.ref.current, {
        attributes: true,
        attributeFilter: ["style"],
      });
    }
  }, []);
  return { textareaSize, setTextareaSize };
};

// 📌 Hook pour gérer les mentions dans le texte
export const useMentionsAndVariables = (
  mentions: Record<string, { name: string }> | undefined,
  variables: Record<string, string | null>
) => {
  // Remplace les @nom par $MENTION et les $VARIABLE par des $
  const normalizeMentionsAndVariables = (text: string) => {
    let parsedInput = text;
    Object.entries(mentions || {}).forEach(([key, value]) => {
      parsedInput = parsedInput?.replaceAll(`@${value.name}`, key);
    });
    Object.entries(variables || {}).forEach(([key, value]) => {
      if (!value) return;
      parsedInput = parsedInput?.replaceAll(value, key);
    });
    return parsedInput;
  };

  // Remplace les $MENTION et les $VARIABLE par des <span>
  const generateMentionOrVariableSpans = (input: string) => {
    const parsedInput = input
      ?.replaceAll(/(\$MENTION\d+)/g, (match) => {
        const mentionName = mentions?.[match]?.name;
        return mentionName
          ? `<span class="bg-brand_focus bg-opacity-20 text-brand_darker rounded-md">@${mentionName}</span>`
          : match;
      })
      .replaceAll(/(\$\w+)/g, (match) => {
        const variableValue = variables?.[match];
        return variableValue
          ? `<span class="underline decoration-dashed underline-offset-2">${variableValue}</span>`
          : match;
      });
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: parsedInput,
        }}
      />
    );
  };

  // Affiche les noms des mentions (ex: $MENTION1 -> @nom)
  // ou les valeurs des variables (ex: $VARIABLE -> valeur)
  const displayMentionOrVariableNames = (input: string) => {
    const normalizedInput = input
      ?.replace(/\$(MENTION\d+)/g, (match) => {
        return mentions?.[match]?.name ? `@${mentions[match].name}` : match;
      })
      .replaceAll(/(\$\w+)/g, (match) => {
        return variables?.[match] ? variables[match] : match;
      });
    return normalizedInput;
  };

  return {
    normalizeMentionsAndVariables,
    generateMentionOrVariableSpans,
    displayMentionOrVariableNames,
  };
};
